import './App.scss'
import React, {  } from 'react' //useEffect
import 'bootstrap';
import MediaQuery from 'react-responsive';

import Main from './components/Main'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
// import {ExpoScaleEase} from 'gsap/EasePack'


import phone1 from './Assets/nexgtv-entertainment-mobile-app-development.png'
import phone2 from './Assets/nexgtv-mobile-app-ui-design.png'
import phone3 from './Assets/nasa-fitness-tracking-mobile-app.png'
import phone4 from './Assets/measure-total-body-weight-through-fitness-app.png'
import phone5 from './Assets/domi-img1.png'
import phone6 from './Assets/ux-strategy-for-mobile-app-devlopment.png'
import phone7 from './Assets/karavan-social-networking-app-screen.png'
import phone8 from './Assets/karavan-social-networking-app-screen-2.png'
import phone9 from './Assets/social-networking-app-case-study.png'
import phone10 from './Assets/developers-for-social-media-app.png'
import phone11 from './Assets/karavan_2.png'
import phone12 from './Assets/melltoo-img1.png'
import phone13 from './Assets/melltoo-img2.png'


import halfPhone1 from './Assets/veme-blockchain-app-developed.png'
import halfPhone2 from './Assets/veme-app-ui-design.png'

import nasaLogo from './Assets/nasa-mobile-app.png'

import img1 from './Assets/erp-app-development-service.png'
import interior from './Assets/interior.jpg'

import appBadge from './Assets/mobile-app-of-the-year-by-entrepreneur.png'
import appBadge2 from './Assets/world-communication-awards-for-best-digital-experience.png'

import pizzaBox from './Assets/pizza_box.png'
import domBread1 from './Assets/dominos-bread1.png'
import domBread2 from './Assets/dominos-bread.png'
import MainCarousel from './MainCarousel';


gsap.registerPlugin(ScrollTrigger);

function App () {

  

 

const texts = {
  page1:{
    key:'11',
circle:{
      above:null,
      big:'25M+ Downloads',
      footer:'on appstore & google playstore'
    },
    h1: 'ABC 123',
    small:'we are the best web development company in the world',
    media:{
      one:phone1,
      two:phone2,
      badge:appBadge2,
    },
  },
  page2:{
    key:'22',
circle:{
      big:'Blockchain',
      above:'the Next Big',
      footer:'Revolution'
    },
    h1: 'ABC 234',
    small:'we are the best web development company in the world',
    media:{
      one:halfPhone1,
      two:halfPhone2,
      badge:null,
    },
  },
  page3:{
    key:'33',
circle:{
      big:nasaLogo,
      img:true,
      above:'powered by advance',
      footer:'Algorithm'
    },
    h1: 'ABC 345',
    small:'we are the best web development company in the world',
    media:{
      one:phone3,
      two:phone4,
      badge:null,
    },
  },
  page4:{
    key:'44',
circle:{
      big:'Redefining',
      above:'UX Strategy',
      footer:'and UI design'
    },
    h1: 'ABC 456',
    small:'we are the best web development company in the world',
    media:{
      one:phone5,
      two:phone6,
      badge:null,
      box:pizzaBox,
      bread1:domBread1,
      bread2:domBread2,
    },
  },
  page5:{
    key:'55',
circle:{
      big:'Text Headline',
      above:'Text Headline',
      footer:'Footer headline'
    },
    h1: 'ABC 567',
    small:'we are the best web development company in the world',
    media:{
      one:phone7,
      two:phone8,
      three:phone9,
      four:phone10,
      five:phone11,
      badge:null,

    },
  },
  page6:{
    key:'66',
circle:{
      big:'Text Headline',
      above:'Developing ERP Solution for',
      footer:'in Furniture industry'
    },
    h1: 'ABC 678',
    small:'we are the best web development company in the world',
    media:{
      one:img1,
      two:null,
      interior:interior,
      badge:null,
    },
  },
  page7:{
    key:'77',
circle:{
      big:'East Asia',
      above:'Biggest Classifieds',
      footer:'Countries'
    },
    h1: 'ABC 23478',
    small:'we are the best web development company in the world',
    media:{
      one:phone12,
      two:phone13,
      badge:appBadge,
    },
  },
}

  return (
    <>    
  <MediaQuery minWidth={769}>
    <Main texts={texts}/>
  </MediaQuery>

  <MediaQuery maxWidth={768}>
    <MainCarousel texts={texts}/>
  </MediaQuery>
    </>
  )
}

export default App